// extracted by mini-css-extract-plugin
export default {"timeComponent":"TimeSelectorV2__timeComponent___jkIn9","timeSvg":"TimeSelectorV2__timeSvg___YNw_j"};